import { render, staticRenderFns } from "./MetamaskLogin.vue?vue&type=template&id=7dc10e98&scoped=true&"
import script from "./MetamaskLogin.vue?vue&type=script&lang=js&"
export * from "./MetamaskLogin.vue?vue&type=script&lang=js&"
import style0 from "./MetamaskLogin.vue?vue&type=style&index=0&id=7dc10e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc10e98",
  null
  
)

export default component.exports